import React, {useEffect, useState} from "react";
import Page from "../../Components/Page";
import {useParams} from "react-router-dom";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import {getStringParamOrDefault, updateQueryStringForState} from "../../../utils/urlBuilder";
import DateRangeInput from "../../Components/DateRangePicker";
import ReactTable from "../../Components/ReactTable";
import {todayChicago} from "../../Alerts/MissingData/filters";
import moment from "moment/moment";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import {makeApiCall} from "../../../Api/makeApiCall";
import _ from "lodash";
import CsvDownload from "../../../utils/CsvDownloadWithNulls";

function MAPAsins() {
    const params = useParams();
    const brandId = parseInt(params.brandId);
    const brandName = getStringParamOrDefault('brandName');
    const today = todayChicago()
    const yesterday = moment(today).subtract(1, 'days').format('YYYY-MM-DD');
    const lastWeek = moment(today).subtract(7, 'days').format('YYYY-MM-DD');

    const [startDate, setStartDate] = useState(getStringParamOrDefault('startDate', lastWeek));
    const [endDate, setEndDate] = useState(getStringParamOrDefault('endDate', yesterday));
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = () => {
        setLoading(true)
        makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/asinsByBrand?brand_id=${brandId}&start_date=${startDate}&end_date=${endDate}`)
            .then(data => setData(data))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        setData([])
    }, [startDate, endDate]);

    useEffect(() => {
        getData();
    }, []);

    const handleDateChange = ({fromFormatted, toFormatted}) => {
        setStartDate(fromFormatted || null);
        setEndDate(toFormatted || null);
        updateQueryStringForState({startDate: fromFormatted, endDate: toFormatted});
    };
    function transformData(data) {
        function remove_unwanted_characters(item) {
            if (item) {
                return item.replace(/[\n\r]/g, "");
            }
        }

        return data.map(item => ({
            "ASIN": item.asin,
            "ASIN Title": remove_unwanted_characters(item.asin_title),
            "MAP": item.enforcement_price ? calculatePrice(item.enforcement_price) : "0.00",
            "Violation Count": item.violation_count.toString()
        }));

    }
    function downloadCsv() {
        if (!loading)
            CsvDownload(transformData(data), `MAPAsins_${brandName}.csv`)
    }
    const calculatePrice = price => (Math.round(price * 100) / 100).toFixed(2);

    const customColumns = [
        {
            header: "ASIN",
            filterable: true,
            accessorKey: "asin",
            cell: ({getValue}) => <a
                href={`/mapMerchants?brandId=${brandId}&brandName=${brandName}&startDate=${startDate}&endDate=${endDate}&asin=${getValue()}`}
                rel="noopener noreferrer">{getValue()}</a>,
        },
        {
          header: "ASIN Title",
          accessorKey: "asin_title",
        },
        {
            header: "MAP",
            accessorKey: "enforcement_price",
            accessorFn: (row) => { return row.enforcement_price ? calculatePrice(row.enforcement_price) : "0.00"; }
        },
        {
            header: "Violation Count",
            accessorKey: "violation_count",
        },
    ]

    return (
        <Page name={`MAP Asins: ${brandName}`}
              breadCrumbs={<Breadcrumbs items={[{
                  label: "MAP Enforcement Dashboard",
                  to: '/mapEnforcementDashboard/'
              },
                  {label: "MAP Asins"}]}/>}
        >
            <div className="dates-container">
                <div>
                    <DateRangeInput
                        data-testid="date-range-input-wrapper"
                        startDate={startDate}
                        endDate={endDate}
                        onChange={handleDateChange}
                        maxDate={todayChicago().format("YYYY-MM-DD")}
                        numberOfMonths={1}
                        allowManualInput={true}
                    />
                </div>
                <div className='client-dashboard-submit-button-container'>
                    <button
                        className='button'
                        data-testid={'client-dashboard-start-date-button'}
                        onClick={() => getData()}
                    >
                        Submit
                    </button>
                </div>
                <div className='client-dashboard-download-csv-button-container'>
                    <button
                        className='button'
                        data-testid={'map-asins-download-csv-button'}
                        onClick={() => {
                            downloadCsv()
                        }}
                    >

                        Export Csv
                    </button>
                </div>

            </div>
            <LoadingWrapper loading={loading}>
                {!_.isEmpty(data) &&
                <ReactTable
                    filterable
                    data={data}
                    columns={customColumns}
                    initialState={{
                        pagination: {pageSize: 25},
                        sorting: [{id: "asin", desc: false}]
                    }}
                />}
            </LoadingWrapper>
        </Page>
    );
}

export default MAPAsins;
